import { createApp } from "vue";
//import store from "./store";
import App from "moodleDir/procollege/lib/vue/App.vue";
import breadcrumbs from "moodleDir/procollege/lib/vue/breadcrumbs.vue";
import desktop2 from "moodleDir/blocks/psm_desktop2/components/desktop2.vue";
import manageGroupsApp from "moodleDir/blocks/manage_groups/App.vue";


import { createWebHashHistory, createRouter } from "vue-router";
import axios, { AxiosError } from "axios";
import accessDenied from "moodleDir/procollege/lib/vue/access-denied.vue";
import eventBus from "moodleDir/procollege/lib/vue/EventBus.js";
// -----------Vuetify---------------
import "vuetify/styles";
import { createVuetify } from "vuetify";
import { ru } from "vuetify/locale";
import colors from "vuetify/lib/util/colors.mjs";
import * as vuetify_components from "vuetify/components";
import * as vuetify_directives from "vuetify/directives";
import { isHTML } from "moodleDir/procollege/lib/vue/helpers.js";

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
/**
 *
 * @param {AxiosError} error
 */
let axiosDefaultErrorHandler = function (error) {
  if (error.response) {
    if (!isHTML(error.response.data)) {
      eventBus.$emit("show-dialog", {
        title: "Ошибка",
        content: error.response.data,
      });
    } else {
      console.log(error.response.data);
    }
  } else {
    console.log(error);
  }
};

/**
 * хотелось бы использовать переменные в require.context, но webpack даже строковые константы
 * не понимает тогда https://github.com/webpack/webpack/issues/4772
 */

/*store.subscribe((mutation, state) => {
  localStorage.setItem("ProCollegeStore", JSON.stringify(state));
});*/

let blockContext = {
  routers: {
    minobr: require.context(
      "moodleDir/report/minobr/",
      true,
      /^(?!node_modules).*\/router.js$/i
    ),
    manage_groups: require.context(
      "moodleDir/blocks/manage_groups/",
      true,
      /^\.\/(?!admission\/(?:createApplicant|rating)(?:\/|$))((admission|clientsInfo|export|secretariat|dictionaries|documents3|documents4|errorlog|gradesBook2|plan3|service|tariffication|reportsLocal|timetable2)\/.*)?router\.js$/i
    ),
    psm_desktop2: require.context(
      "moodleDir/blocks/psm_desktop2/",
      true,
      /^(?!node_modules).*\/router.js$/i
    ),
    //'psm_test' : require.context('moodleDir/blocks/psm_test/', true, /^(?!node_modules).*\/router.js$/i)
  },
  widgets: {
    minobr: require.context(
      "moodleDir/report/minobr/",
      true,
      /^.*widgets\/.*\.vue$/i
    ),
    manage_groups: require.context(
      "moodleDir/blocks/manage_groups/",
      true,
      /\/(admission)\/widgets\/.*\.vue$/i
    ),
    psm_desktop2: require.context(
      "moodleDir/blocks/psm_desktop2/",
      true,
      /^.*widgets\/.*\.vue$/i
    ),
  },
};

//-------------load components------------------------
function findWidgets(app, blockName) {
  if (blockContext.widgets[blockName] !== undefined) {
    let context = blockContext.widgets[blockName];
    context.keys().forEach((cPath) => {
      let folder = cPath.split("/");
      let component = blockName;
      for (let i = 1; i < folder.length; i++) {
        component += "_" + folder[i];
      }
      component = component.replace(".vue", "");
      app.component(component, context(cPath).default || context(cPath));
    });
  }
}

function isPermittedComponent(componentUrl, modules, root) {
  componentUrl=componentUrl.replace(/:.*$/,"");
  componentUrl=componentUrl.toLowerCase()

  if (componentUrl === "/") {
    return true;
  }

  for (let moduleName in modules) {
    let t = root + moduleName + "/";
    t=t.toLocaleLowerCase()

    if (componentUrl == t) {
      return true;
    }

    if (componentUrl.match(t)) {
      if (Object.keys(modules[moduleName]["modules"]).length > 0) {
        return isPermittedComponent(
          componentUrl,
          modules[moduleName]["modules"],
          t
        );
      }
      else {
        return isPermittedComponent(
          modules[moduleName]["url"],
          modules,
          root
        );
      }
      
    }
  }
  return false;
}


if (typeof model !== "undefined") {
  //console.log(model);
  let blockName = model["blockName"];
  let routes = [];
  //-----------load routes---------
  if (blockContext.routers[blockName] === undefined) {
    console.log("block " + blockName + " not found");
    console.trace();
  } else {
    let context = blockContext.routers[blockName];

    context.keys().forEach((rPath) => {
      let folderParts = rPath.split("/");
      folderParts.shift(); //shift ".""
      folderParts.pop(); //pop "router.js"
      /*
      if (folder == null) {
        return;
      }
      */
      //folder = folder[1] === "" ? "/" : folder[1];
      context(rPath).default.routes.forEach((route) => {
        if (folderParts.length == 0) {
          route.path = "/";
          route.name = blockName + "_" + route.name; //like minobr_akt_report_akt
        } else {
          route.path = "/" + folderParts.join("/") + route.path;
          route.name =
            blockName + "_" + folderParts.join("_") + "_" + route.name; //like minobr_akt_report_akt
        }

        //console.log(route.path)
        //console.log(isPermittedComponent(route.path,model["modules"],"/"))
        //console.log("---------------------------------")
        //добавляем все роуты, которые есть в наличии, но компонент для обработки подменяем на accessDenied
        //для тех роутов, к которым в model['modules'] не нашлось контроллера
        if (isPermittedComponent(route.path,model["modules"],"/") === false) {
          route = {
            path: route.path,
            component: accessDenied,
            name: route.name,
          };
        }
        routes.push(route);
      });
    });
  }
  //console.log(routes)
  //------------------------------
  let router = null;
  const vuetify = createVuetify({
    locale: {
      messages: { ru },
    },
    theme: {
      defaultTheme: 'light',
      themes: {
        light: {
          colors: {
            primary: colors.blue.darken2,
          },
        },
        dark: {
          colors: {
            primary: colors.blue.darken2,
          },
        },
      },
    },
    components: {
      vuetify_components,
      //VDataTable,
    },
    vuetify_directives,
    icons: {
      defaultSet: "mdi",
    },
  });

  if (
    document.getElementById("procollege_vue") != null ||
    document.getElementById("procollege_vue_navigation") != null
  ) {
    router = createRouter({
      history: createWebHashHistory(),
      routes,
    });
  }
  //--------------------------------------------------
  if (document.getElementById("procollege_vue") != null) {
    const app = createApp({
      extends: App,
    });
    app.config.globalProperties.axios = axios;
    app.config.globalProperties.axiosDefaultErrorHandler =
      axiosDefaultErrorHandler;

    app.config.globalProperties.$eventBus = eventBus;
    app.config.globalProperties.$model = model;
    findWidgets(app, blockName);
    app.use(vuetify).use(router).mount("#procollege_vue");
  }
  //----------------------------
  //----------------------------
  if (document.getElementById("procollege_vue_navigation") != null) {
    const bc = createApp({
      extends: breadcrumbs,
      beforeCreate() {
        //this.$store.commit("initialiseStore");
      },
    });
    bc.config.globalProperties.$model = model;
    bc.config.globalProperties.$eventBus = eventBus;

    bc.use(vuetify).use(router).mount("#procollege_vue_navigation");
  }
  //------------------------------
  if (document.getElementById("procollege_desktop2") != null) {
    const desktop = createApp({
      extends: desktop2,
      beforeCreate() {
        //this.$store.commit("initialiseStore");
      },
    });
    desktop.config.globalProperties.axios = axios;
    desktop.config.globalProperties.axiosDefaultErrorHandler =
      axiosDefaultErrorHandler;
    desktop.config.globalProperties.$model = model;
    desktop.config.globalProperties.$eventBus = eventBus;
    findWidgets(desktop, blockName);
    desktop.use(vuetify).mount("#procollege_desktop2");
  }
  //------------меню------------------
  if (document.getElementById("procollege_block_navigation") != null) {
    const mgMenu = createApp({
      extends: manageGroupsApp,
      beforeCreate() {
        //this.$store.commit("initialiseStore");
      },
    });
    mgMenu.config.globalProperties.axios = axios;
    mgMenu.config.globalProperties.axiosDefaultErrorHandler =
      axiosDefaultErrorHandler;
    mgMenu.config.globalProperties.$model = procollege_block_model;
    mgMenu.config.globalProperties.$eventBus = eventBus;

    mgMenu.use(vuetify).mount("#procollege_block_navigation");
  }
}
